import React from 'react';

const STEPS = [
  { label: 'Eligibility Check', path: '/descent/checker' },
  { label: 'Documents', path: '/descent/checklist' },
  { label: 'Apply', path: '/descent/apply' },
  { label: 'Passport', path: '/after/passport' },
  { label: 'Settle In', path: '/after/settling' },
];

export default function ProgressBar({ currentPath, onNavigate }) {
  const activeIndex = STEPS.findIndex((s) => currentPath.startsWith(s.path));
  if (activeIndex === -1) return null;

  return (
    <div className="no-print" style={{
      overflowX: 'auto',
      padding: '10px 20px',
      backgroundColor: '#f9fafb',
      borderBottom: '1px solid #e5e7eb',
    }}>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '4px',
        minWidth: 'max-content',
      }}>
        {STEPS.map((step, i) => {
          const isActive = i === activeIndex;
          const isDone = i < activeIndex;
          const bg = isActive ? '#2563eb' : isDone ? '#d1fae5' : '#f3f4f6';
          const color = isActive ? '#fff' : isDone ? '#065f46' : '#9ca3af';
          const weight = isActive ? '700' : isDone ? '600' : '400';

          return (
            <React.Fragment key={step.path}>
              {i > 0 && (
                <div style={{ width: '20px', height: '2px', backgroundColor: isDone ? '#6ee7b7' : '#e5e7eb', flexShrink: 0 }} />
              )}
              <button
                onClick={() => onNavigate && onNavigate(step.path)}
                style={{
                  padding: '4px 12px',
                  borderRadius: '99px',
                  border: 'none',
                  backgroundColor: bg,
                  color,
                  fontSize: '0.78rem',
                  fontWeight: weight,
                  cursor: onNavigate ? 'pointer' : 'default',
                  whiteSpace: 'nowrap',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '4px',
                }}
              >
                {isDone && <span>✓</span>}
                {i + 1}. {step.label}
              </button>
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
}
